<template>
  <div
    role="button"
    class="flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200"
  >
    <icon-base
      class="-translate-y-0-5 transform"
      icon="x"
      width="16"
      height="16"
    />
  </div>
</template>

<script setup lang="ts">
import IconBase from "@/components/ui/IconBase.vue";
</script>
